import { render, staticRenderFns } from "./vpc-overview.vue?vue&type=template&id=6216a667&scoped=true"
import script from "./vpc-overview.ts?vue&type=script&lang=ts&external"
export * from "./vpc-overview.ts?vue&type=script&lang=ts&external"
import style0 from "./vpc-overview.less?vue&type=style&index=0&id=6216a667&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6216a667",
  null
  
)

export default component.exports